import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import EditIcon from '@material-ui/icons/Edit';
import { appTheme } from '../../theme';
import Button from './Button';
import HeaderTitle from './HeaderTitle';

const Header = styled.header`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: ${appTheme.spacing.default} 0;
`;

function PageHeader({ onEdit, shouldShowEdit, title }) {
  return (
    <Header>
      <HeaderTitle>{title}</HeaderTitle>
      {shouldShowEdit && (
        <Button color="default" icon={EditIcon} onClick={onEdit} variant="text">
          Edit
        </Button>
      )}
    </Header>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,

  onEdit: PropTypes.func,
  shouldShowEdit: PropTypes.bool,
};

PageHeader.defaultProps = {
  onEdit: () => {},
  shouldShowEdit: false,
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/modules/common/PageHeader.js